const MAX_LOADING_MS = 20000;

let activeType = '';
let listeners = [];
let timeoutId = null;

const notify = () => {
  listeners.forEach((listener) => {
    listener(activeType);
  });
};

export const getDeliverTabLoading = () => activeType;

export const subscribeDeliverTabLoading = (listener) => {
  if (typeof listener !== 'function') {
    return () => {};
  }
  listeners.push(listener);
  listener(activeType);
  return () => {
    listeners = listeners.filter((item) => item !== listener);
  };
};

export const startDeliverTabLoading = (type) => {
  const nextType = String(type || '').trim().toLowerCase();
  if (!nextType) {
    return;
  }
  activeType = nextType;
  if (timeoutId) {
    clearTimeout(timeoutId);
  }
  timeoutId = setTimeout(() => {
    timeoutId = null;
    if (activeType) {
      activeType = '';
      notify();
    }
  }, MAX_LOADING_MS);
  notify();
};

export const stopDeliverTabLoading = () => {
  if (timeoutId) {
    clearTimeout(timeoutId);
    timeoutId = null;
  }
  if (!activeType) {
    return;
  }
  activeType = '';
  notify();
};



// WEBPACK FOOTER //
// ./src/utils/deliverTabLoading.js